import { Popover } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SPopover = styled(Popover)``;
